import React, { useEffect } from "react"

function Home(props) {
  useEffect(() => {document.title = props.title})
  
  return (
    <main id="main-content">
    <h1>{props.title}</h1>
    
      <div id="home">
        <h2>Home of Least1234</h2>
        <p>Welcome to the Least1234 website!</p>
        <br />
        <p>Most Recent Video</p>
        <div className="iframe-container">
          <iframe className="yt-video" src="https://www.youtube.com/embed/Kzq40NUIuI8" title="Dorney Park in Open RollerCoaster Tycoon 2" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy"></iframe>
        </div>
      </div>
    </main>
  )
}

export default Home